import { Component, Input } from '@angular/core';
import { Recipient } from '../../../interfaces/recipient';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { Approval, ApprovalColumn, ApprovalColumnLabels, ApprovalStatus } from '../../../interfaces/approval';

@Component({
    selector: 'app-approval-box',
    imports: [MatIconModule, CommonModule],
    templateUrl: './approval-box.component.html',
    styleUrl: './approval-box.component.scss'
})
export class ApprovalBoxComponent {
  @Input() approval?: Approval;
  approvalColumnLabels = ApprovalColumnLabels; // Label mapping
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    // Register your SVG icons here
    this.matIconRegistry.addSvgIcon('human-male', this.domSanitizer.bypassSecurityTrustResourceUrl('/human-male.svg'));
    this.matIconRegistry.addSvgIcon('human-female', this.domSanitizer.bypassSecurityTrustResourceUrl('/human-female.svg'));
  }

  get age(): number {
    const participantDob = this.approval?.recipient?.dob;
    if (participantDob) {
      const birthDate = new Date(participantDob);
      const ageDiffMs = Date.now() - birthDate.getTime();
      const ageDate = new Date(ageDiffMs);
      return Math.abs(ageDate.getUTCFullYear() - 1970); // Calculate age
    }
    return 0; // Default if no DOB is provided
  }

  /**
   * Format acceptable blood types as comma-separated for display
   */
  get formattedAcceptableBloodTypes(): string {
    if (!this.approval?.recipient?.acceptableBloodTypes) return '';
    return this.approval.recipient.acceptableBloodTypes.replace(/\s+/g, ', ');
  }

  /**
   * Get the sanitized request comment with fixed links
   */
  get sanitizedRequestComment(): string {
    if (!this.approval?.requestComment) return '';
    return this.fixLinksInHtml(this.approval.requestComment);
  }

  /**
   * Fix links in HTML to ensure they have proper protocols and open in new tab
   */
  private fixLinksInHtml(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;

    const links = div.querySelectorAll('a');
    links.forEach(link => {
      let href = link.getAttribute('href');
      if (href && !href.match(/^https?:\/\//i) && !href.match(/^mailto:/i) && !href.match(/^tel:/i)) {
        // Add https:// if no protocol is present
        link.setAttribute('href', 'https://' + href);
      }
      // Make all links open in new tab
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });

    return div.innerHTML;
  }
}
